/* global axios */

import ApiClient from './ApiClient';

class AccountBrandingAPI extends ApiClient {
  constructor() {
    super('branding_setting', { accountScoped: true });
  }

  updateBranding(data) {
    return axios.patch(this.url, data);
  }

  resetBranding() {
    return axios.delete(this.url);
  }
}

export default new AccountBrandingAPI();
